import * as yup from 'yup';
import { validationErrors } from 'src/utils/validation/validationErrors';
import {
  LINKEDIN,
  validationRules,
} from 'src/utils/validation/validationRules';

export const newContactValidationSchema = yup.object().shape({
  first_name: validationRules.USER_FIRST_NAME.required(
    validationErrors.REQUIRED_FIELD,
  ),
  last_name: validationRules.USER_LAST_NAME.required(
    validationErrors.REQUIRED_FIELD,
  ),
  gender: yup.string().required(validationErrors.REQUIRED_FIELD),
  title: validationRules.USER_TITLE.required(validationErrors.REQUIRED_FIELD),
  company_name: validationRules.USER_COMPANY_NAME.required(
    validationErrors.REQUIRED_FIELD,
  ),
  linkedin: LINKEDIN.required(validationErrors.REQUIRED_FIELD),
  country: validationRules.ARRAY_OF_NUMBERS_REQUIRED,
  expertise: validationRules.ARRAY_OF_NUMBERS_REQUIRED,
  available: validationRules.ARRAY_OF_NUMBERS_REQUIRED,
  description: validationRules.yupMaxLongStr
    .min(100, 'This field must be at least 100 characters')
    .required(validationErrors.REQUIRED_FIELD),
  rating: yup
    .number()
    .min(0.5, 'Must be bigger that 0')
    .required(validationErrors.REQUIRED_FIELD)
    .typeError(validationErrors.REQUIRED_FIELD),

  is_company_logo_visible: yup.boolean(),
  guest_company_logo: yup.mixed().when('is_company_logo_visible', {
    is: true,
    then: yup.mixed().required(validationErrors.REQUIRED_FIELD),
  }),

  is_company_description_visible: yup.boolean(),
  guest_company_description: yup
    .string()
    .nullable()
    .when('is_company_description_visible', {
      is: true,
      then: validationRules.yupMaxStr.required(validationErrors.REQUIRED_FIELD),
    }),
});
